import { render } from "./AdminMaster.vue?vue&type=template&id=db6853d8"
import script from "./AdminMaster.vue?vue&type=script&lang=js"
export * from "./AdminMaster.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__